// extracted by mini-css-extract-plugin
module.exports = {"realmList":"styles_realmList__3e_u7","realm":"styles_realm__3Y5hZ","realmName":"styles_realmName__3n_oG","realmIcon":"styles_realmIcon__2AXSo"};